<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte'; 
    import TopInfo from '../components/TopInfo.svelte';  
    import Preloader from '../components/Preloader.svelte'; 

    let isLoading = false;


    onMount(async() => {

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }
    })


    let image_url = 'https://docs.datalogics.co.il/products/';

    let services = [
        {
            'name':'מערכת ליקוט',
            'img' :image_url + 'likut.svg',
            "desc" :"המערכת מאפשרת ליקוט בצורה מהירה וחכמה עם אפשרות סריקת ברקודים והדפסה אוטומטית"
        },
        {
            'name':'מערכת החזרות והחלפות',
            'img' :image_url + 'returns.svg',
            "desc":"המערכת מתממשקת לאתר ומאפשרת ביצוע של בקשת החלפה והחזרה של פריטים באופן עצמאי על ידי לקוחותיכם"
        },
        {
            'name':'אינטגרציה לוריפון Verifone',
            'img' :image_url + 'verifone.svg',
            'desc':"האינטגרציה כוללת: הקמה אוטומטית של מוצרים, סינכרון מלאים , סינכרון לקוחות , סינכרון הזמנות והוצאת חשבוניות בקופה"
        },
        {
            'name':'אינטגרציה לפריוריטי Priority',
            'img' : image_url + 'priority.svg',
            'desc':"האינטגרציה כוללת: הקמה אוטומטית של מוצרים, סינכרון מלאים , סינכרון לקוחות , סינכרון הזמנות והוצאת חשבוניות בקופה"
        },
        {
            'name':'אינטגרציה לכספית Hyp',
            'img' : image_url + 'hyp.svg',
            'desc':"האינטגרציה כוללת: הקמה אוטומטית של מוצרים, סינכרון מלאים , סינכרון לקוחות , סינכרון הזמנות והוצאת חשבוניות בקופה"
        },
        {
            'name':'אינטגרציה לקומקס Comax',
            'img' : image_url + 'comax.svg',
            'desc':"האינטגרציה כוללת: הקמה אוטומטית של מוצרים, סינכרון מלאים , סינכרון לקוחות , סינכרון הזמנות והוצאת חשבוניות בקופה"
        },
        {
            'name':'אינטגרציה אופנת תוכנה Otech',
            'img' : image_url + 'otech.svg',
            'desc':"האינטגרציה כוללת: הקמה אוטומטית של מוצרים, סינכרון מלאים , סינכרון לקוחות , סינכרון הזמנות והוצאת חשבוניות בקופה"
        },
        {
            'name':'אינטגרציה לנייקס Nayax',
            'img' : image_url + 'nayax.svg',
            'desc':"האינטגרציה כוללת: הקמה אוטומטית של מוצרים, סינכרון מלאים , סינכרון לקוחות , סינכרון הזמנות והוצאת חשבוניות בקופה"
        },
        {
            'name':'אינטגרציה לסאפ Sap',
            'img' : image_url + 'sap.svg',
            'desc':"האינטגרציה כוללת: הקמה אוטומטית של מוצרים, סינכרון מלאים , סינכרון לקוחות , סינכרון הזמנות והוצאת חשבוניות בקופה"
        },
        {
            'name':'אינטגרציה לאידאה Edea',
            'img' : image_url + 'edea.svg',
            'desc':"האינטגרציה כוללת: הקמה אוטומטית של מוצרים, סינכרון מלאים , סינכרון לקוחות , סינכרון הזמנות והוצאת חשבוניות בקופה"
        },
        {
            'name':'אינטגרציה לחשבשבת',
            'img' : image_url + 'hashav.svg',
            'desc':"האינטגרציה כוללת: הקמה אוטומטית של מוצרים, סינכרון מלאים , סינכרון לקוחות , סינכרון הזמנות והוצאת חשבוניות בקופה"
        },
        {
            'name':'אינטגרציה לריווחית',
            'img' : image_url + 'rivhit.svg',
            'desc':"האינטגרציה כוללת: הקמה אוטומטית של מוצרים, סינכרון מלאים , סינכרון לקוחות , סינכרון הזמנות והוצאת חשבוניות בקופה"
        }        
    ];




    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment">
            <h1 class="text-start">{$_('services.title')}</h1>
            <p>למידע נוסף יש לפנות לכתובת: 
                {#if shippingo=="0" || shippingo=="2"}
                <a href="mailto:tal@datalogics.co.il">tal@datalogics.co.il</a>
                {:else if shippingo=="2"}
                <a href="mailto:info@shippingo.ai">info@shippingo.ai</a>
                {/if}                
            </p>
            <div class="flex-col">
                {#each services as service}
                    <div class="flex border">
                        <div class="image"><img src="{service.img}"></div>
                        <div class="name">
                            <div>{service.name}</div>
                            <div class="desc">{service.desc}</div>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
        
    </div>
</div>
<style>
    p {
        font-size:14px;
        font-weight: bold;
    }
    .desc {
        font-size:14px;
    }
    .border {
        border:1px solid #efefef;
    }
    .image img {
        width:60px;
    }
    .name {
        
        padding-right:10px;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }
    .flex {
        display: flex;
        align-items: center;
    }
</style>
